import React, { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

import { Button, ButtonColor, ButtonVariant } from '@videoblocks/storywind';

import './UnlockCreativeFreedom.css';

export interface UnlockCreativeFreedomPropTypes {
  content: string;
  showCallToAction?: boolean;
  h1Header?: boolean;
  callToActionType?: ButtonVariant;
  callToActionHref?: string;
  callToActionText?: string;
  callToActionColor?: ButtonColor;
  imageSrc?: string;
  imageSourceAlt?: string;
  heading: string;
  subHeading: string;
  classNames?: string;
}

export const UnlockCreativeFreedom = ({
  content,
  showCallToAction,
  h1Header,
  callToActionType,
  callToActionHref,
  callToActionText,
  callToActionColor,
  imageSrc,
  imageSourceAlt,
  heading,
  subHeading,
  classNames,
}: UnlockCreativeFreedomPropTypes): ReactElement => {
  return (
    <section
      id="unlock-creative-freedom-container"
      className={twMerge(classNames, 'w-full text-white')}
    >
      <div
        className="
          py-12
          px-6
          maker-md:px-50
          ppro-lg:px-52
          lg:px-168
          flex
          flex-col
          flex-nowrap
          items-center
          gap-8
          justify-center"
      >
        <div className="w-96 ppro-sm:w-553px flex flex-col items-center">
          {subHeading && (
            <div className="text-sm font-normal tracking-widest">
              {subHeading.toUpperCase()}
            </div>
          )}

          {h1Header ? (
            <h1 className="font-bold text-3xl lg:text-5xl md:mb-6 md:mt-6">
              {heading}
            </h1>
          ) : (
            <h2 className="font-bold text-3xl lg:text-5xl md:mb-6 md:mt-6 font-serif">
              {heading}
            </h2>
          )}
          <div
            className={
              'text-center font-normal text-base md:text-xl leading-7 md:mb-6'
            }
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
          <div className="text-center flex justify-start">
            {showCallToAction && (
              <div className="flex justify-start text-center pt-4">
                <Button
                  className={twMerge(
                    callToActionHref && 'text-black no-underline'
                  )}
                  href={callToActionHref}
                  variant={callToActionType}
                  color={callToActionColor}
                >
                  {callToActionText}
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="w-full text-center">
          <div className="overflow-hidden">
            <img src={imageSrc} alt={imageSourceAlt} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default UnlockCreativeFreedom;
